import { render, staticRenderFns } from "./addCard.vue?vue&type=template&id=d6c4ff9e&scoped=true&"
import script from "./addCard.vue?vue&type=script&lang=js&"
export * from "./addCard.vue?vue&type=script&lang=js&"
import style0 from "./addCard.vue?vue&type=style&index=0&id=d6c4ff9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c4ff9e",
  null
  
)

export default component.exports